import { _ as K, a as B, b as ne, c as M, d as pe } from "./TermsModal-BOYgMFEz.js";
import { e as jt, f as Ot, g as Ht, h as Wt, i as Ut, j as Gt, k as Jt, l as Qt, m as Xt, n as Zt, o as en } from "./TermsModal-BOYgMFEz.js";
import { defineComponent as h, resolveComponent as C, unref as p, openBlock as l, createBlock as f, createSlots as oe, withCtx as _, createVNode as m, createCommentVNode as k, computed as c, createElementBlock as v, Fragment as P, createElementVNode as b, toValue as me, defineAsyncComponent as I, resolveDynamicComponent as ve, renderSlot as y, toDisplayString as w, renderList as A, watch as $, normalizeProps as fe, guardReactiveProps as ye, useModel as T, onMounted as be, mergeModels as V, normalizeClass as L, withDirectives as _e, vModelRadio as he, createTextVNode as ke, ref as ae, withModifiers as ge } from "vue";
import { useProviderI18n as x, extractProviderKey as xe, usePaymentPlanService as we, reportSessionError as Ce, formatLocalDate as $e, fullDaysBetween as Pe, useApplicationStore as re, useFieldStore as Se, useProviderStore as ie } from "@versatile-credit-apply/sdk";
import { mapValues as De } from "lodash-es";
import { useI18n as Ke } from "vue-i18n";
import { useIsInStore as Me } from "@versatile-credit-apply/composition";
import { A as nn, _ as on, T as an, V as rn } from "./index-DGODZe-m.js";
import { useDebounceFn as Ie } from "@vueuse/core";
import { _ as le } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { useScopedRegle as Ae } from "@regle/core";
import { requiredIf as Te } from "@regle/rules";
import { faCircleCheck as Ve, faCircle as Be } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon as R } from "@fortawesome/vue-fontawesome";
import Le from "@ui-kit/components/button";
import Re from "@ui-kit/components/drawer";
import { useRoute as se } from "vue-router";
import { _ as sn } from "./TermsModalLink-DoPv0tIG.js";
const S = /* @__PURE__ */ h({
  __name: "DisclosureContact",
  props: {
    providerKey: {},
    applyMode: {},
    vertical: {}
  },
  setup(e) {
    const t = e, { te: n } = x(() => t.providerKey);
    return (o, a) => {
      const r = C("i18n-t");
      return p(n)("contact") ? (l(), f(r, {
        key: 0,
        keypath: "contact",
        tag: "p"
      }, oe({ _: 2 }, [
        e.providerKey ? {
          name: "lender",
          fn: _(() => [
            m(K, { "provider-key": e.providerKey }, null, 8, ["provider-key"])
          ]),
          key: "0"
        } : void 0,
        e.providerKey ? {
          name: "lenderLong",
          fn: _(() => [
            m(K, {
              "provider-key": e.providerKey,
              "display-type": "long"
            }, null, 8, ["provider-key"])
          ]),
          key: "1"
        } : void 0,
        e.providerKey ? {
          name: "website",
          fn: _(() => [
            m(r, {
              keypath: "contact_website",
              tag: "span"
            })
          ]),
          key: "2"
        } : void 0,
        e.providerKey ? {
          name: "bankDefault",
          fn: _(() => [
            m(p(B), { "provider-key": e.providerKey }, null, 8, ["provider-key"])
          ]),
          key: "3"
        } : void 0,
        e.providerKey ? {
          name: "bankShort",
          fn: _(() => [
            m(p(B), {
              "provider-key": e.providerKey,
              "display-type": "short"
            }, null, 8, ["provider-key"])
          ]),
          key: "4"
        } : void 0
      ]), 1024)) : k("", !0);
    };
  }
});
function E(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "synchrony_standard_en",
    resource: {
      contact: { t: 0, b: { t: 2, i: [{ t: 3, v: "You authorize " }, { t: 4, k: "lender" }, { t: 3, v: " to contact you at each phone number you have provided. By providing a cell phone number you agree to receive 1) account updates and information and 2) account security alerts, including text messages from " }, { t: 4, k: "lender" }, { t: 3, v: ". Message frequency varies. Message & data rates may apply. Text HELP for help, text STOP to Opt-Out. Terms & Conditions and Privacy Policy: " }, { t: 4, k: "website" }, { t: 3, v: `.
` }] } },
      contact_website: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "www.synchrony.com" } }
    }
  });
}
function F(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "tdbank_standard_en",
    resource: {
      contact: { t: 0, b: { t: 2, i: [{ t: 3, v: "When you give us your mobile phone number, we have your permission to contact you at that number about all of your " }, { t: 4, k: "lenderLong" }, { t: 3, v: ` accounts. Your consent allows us to use text messaging, artificial or pre-recorded voice messages and automatic dialling technology for informational and account service calls, but not for telemarketing or sales calls. It may include contact from companies working on our behalf to service your accounts. Message and data rates may apply. You may contact us anytime to change these preferences.
` }] } }
    }
  });
}
function N(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "ads_standard_en",
    resource: {
      contact: { t: 0, b: { t: 2, i: [{ t: 3, v: "By providing a mobile number or a number later converted to a mobile number, you agree that " }, { t: 4, k: "bankShort" }, { t: 3, v: ", " }, { t: 4, k: "bankDefault" }, { t: 3, v: ` and their service providers may contact you regarding your accounts at that number, including by autodialer, recorded or artificial voice, and text. Message and data rates may apply.
` }] } }
    }
  });
}
typeof E == "function" && E(S);
typeof F == "function" && F(S);
typeof N == "function" && N(S);
const g = /* @__PURE__ */ h({
  __name: "DisclosureIncome",
  props: {
    providerKey: {},
    applyMode: {},
    vertical: {}
  },
  setup(e) {
    const t = e, { te: n } = x(() => t.providerKey), o = c(
      () => n(`${t.vertical}.income`) ? `${t.vertical}.income` : "income"
    );
    return (a, r) => {
      const i = C("i18n-t");
      return l(), v(P, null, [
        m(i, {
          keypath: o.value,
          tag: "p"
        }, oe({
          wi_note: _(() => [
            m(i, {
              tag: "span",
              class: "font-medium",
              keypath: "wi_note"
            })
          ]),
          wi_disclaimer: _(() => [
            m(i, {
              tag: "span",
              keypath: "wi_disclaimer"
            })
          ]),
          br: _(() => [
            r[0] || (r[0] = b("br", null, null, -1))
          ]),
          _: 2
        }, [
          e.providerKey ? {
            name: "lender",
            fn: _(() => [
              m(K, { "provider-key": e.providerKey }, null, 8, ["provider-key"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["keypath"]),
        p(n)("income_line_2") ? (l(), f(i, {
          key: 0,
          class: "font-bold",
          keypath: "income_line_2",
          tag: "p"
        }, {
          wi_disclaimer: _(() => [
            m(i, {
              class: "font-normal",
              keypath: "wi_disclaimer",
              tag: "span"
            })
          ]),
          _: 1
        })) : k("", !0)
      ], 64);
    };
  }
});
function Y(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3, v: "Alimony, child support or separate maintenance income need not be included unless relied upon for credit. You may include the monthly amount that you have available to spend from your assets. " }, { t: 4, k: "wi_note" }, { t: 3, v: " " }, { t: 4, k: "wi_disclaimer" }, { t: 3, v: `
` }] } },
      wi_disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `If you are applying for an individual account and your spouse also is a WI resident, combine your and your spouse's financial information.
` } },
      wi_note: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `MARRIED WI Residents only:
` } }
    }
  });
}
function q(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "aff_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation.
` } }
    }
  });
}
function z(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "easypay_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3, v: "Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation. For information regarding " }, { t: 4, k: "lender" }, { t: 3, v: `'s Programs, visit www.easypayfinance.com/programs.
` }] } }
    }
  });
}
function j(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "synchrony_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3, v: 'Your "Net Income" includes what you earn or reasonably expect to earn from employment, investments, retirement, social security benefits and public assistance. You can also include money that someone else deposits regularly into your account (individual or joint) and the amount that you have available to spend from your assets. If you are 21 or over, you may also include the amount of someone else’s income that is regularly used to pay your expenses. Alimony, child support or separate maintenance income need not be included unless relied upon for credit. ' }, { t: 4, k: "wi_note" }, { t: 3, v: `: If this is an individual account, please also include your spouse’s income.
` }] } },
      wi_note: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WI Residents Only" } }
    }
  });
}
function O(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "progressive_standard_en",
    resource: {
      income: { t: 0, b: { static: "", t: 2, i: [] } }
    }
  });
}
function H(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "fortiva_standard_dell_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `*Alimony; child support or separate maintenance income need not be included if you do not wish to have it considered as a basis for repaying this obligation.
` } },
      income_line_2: { t: 0, b: { t: 2, i: [{ t: 3, v: "Wisconsin Married Residents: " }, { t: 4, k: "wi_disclaimer" }, { t: 3, v: `
` }] } },
      wi_disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Combine your and your spouse's information." } }
    }
  });
}
function W(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "tdbank_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Alimony, child support, or separate maintenance income need not be revealed if  you do not wish to have it considered as a basis for repaying your obligation. Your total gross annual income is what you earn or reasonably expect to earn  from work, self-employment, interest, dividends, investments, social security  or other benefits. You can also include money that someone else regularly  deposits into your banking account and if you are 21 or older you can include  income from others that you regularly use to pay your bills.
` } }
    }
  });
}
function U(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "ads_standard_en",
    resource: {
      retail: {
        income: { t: 0, b: { t: 2, i: [{ t: 3, v: "Alimony, child support or separate maintenance income need not be included unless relied upon for credit. You may include the monthly amount that you have available to spend from your assets. " }, { t: 4, k: "wi_note" }, { t: 3, v: " " }, { t: 4, k: "wi_disclaimer" }, { t: 3, v: " " }, { t: 4, k: "br" }, { t: 3, v: " " }, { t: 4, k: "br" }, { t: 3, v: ` Income is not provided to all lenders until you decide to proceed with a full application.
` }] } }
      }
    }
  });
}
typeof Y == "function" && Y(g);
typeof q == "function" && q(g);
typeof z == "function" && z(g);
typeof j == "function" && j(g);
typeof O == "function" && O(g);
typeof H == "function" && H(g);
typeof W == "function" && W(g);
typeof U == "function" && U(g);
const ce = /* @__PURE__ */ h({
  __name: "DisclosureBankCard",
  props: {
    providerKey: {},
    applyMode: {},
    vertical: {}
  },
  setup(e) {
    const t = e, { te: n } = x(() => t.providerKey);
    return (o, a) => {
      const r = C("i18n-t");
      return p(n)("bank_card") ? (l(), f(r, {
        key: 0,
        keypath: "bank_card",
        tag: "p"
      })) : k("", !0);
    };
  }
});
function G(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "aff_standard_en",
    resource: {
      bank_card: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Prepaid cards are not accepted.
` } }
    }
  });
}
typeof G == "function" && G(ce);
const Ee = (e) => {
  const t = me(e);
  if (t == null)
    return;
  const n = typeof t == "string" ? t : t.providerKey;
  return n != null ? xe(n) : void 0;
}, Fe = (e, t) => {
  const n = De(
    t,
    (o) => I(o)
  );
  return c(() => {
    const o = Ee(e);
    return o ? n[o] : void 0;
  });
}, Ne = /* @__PURE__ */ h({
  __name: "DisclosurePrequalify",
  props: {
    providerKey: {},
    applyMode: {},
    vertical: {}
  },
  setup(e) {
    const t = e, n = Fe(() => t.providerKey, {
      synchrony_standard: () => import("./SynchronyDisclosurePrequalify-BgwZE0Z8.js"),
      ads_standard: () => import("./AdsDisclosurePrequalify-CoYKqFNr.js"),
      snap_standard: () => import("./SnapDisclosurePrequalify-tbWTmElh.js")
    });
    return (o, a) => (l(), f(ve(p(n)), { "provider-key": e.providerKey }, null, 8, ["provider-key"]));
  }
}), Ye = { key: 0 }, Bt = /* @__PURE__ */ h({
  __name: "DisclosureDictionary",
  props: {
    providerKey: {},
    type: {},
    applyMode: { default: "full" },
    vertical: {}
  },
  setup(e) {
    const t = e, n = c(() => t.type === "contact"), o = c(() => t.type === "income"), a = c(() => t.type === "bank-card"), r = c(
      () => t.type === "prequalify-disclosure" && t.applyMode == "prequalify"
    ), i = c(
      () => n.value || o.value || a.value || r.value
    );
    return (u, s) => i.value ? (l(), v("div", Ye, [
      y(u.$slots, "footnote"),
      n.value ? (l(), f(S, {
        key: 0,
        "provider-key": e.providerKey,
        "apply-mode": e.applyMode
      }, null, 8, ["provider-key", "apply-mode"])) : o.value ? (l(), f(g, {
        key: 1,
        "provider-key": e.providerKey,
        "apply-mode": e.applyMode,
        vertical: e.vertical
      }, null, 8, ["provider-key", "apply-mode", "vertical"])) : a.value ? (l(), f(ce, {
        key: 2,
        "provider-key": e.providerKey,
        "apply-mode": e.applyMode
      }, null, 8, ["provider-key", "apply-mode"])) : r.value ? (l(), f(Ne, {
        key: 3,
        "provider-key": e.providerKey,
        "apply-mode": e.applyMode
      }, null, 8, ["provider-key", "apply-mode"])) : k("", !0)
    ])) : k("", !0);
  }
}), qe = { class: "contents" }, ze = { class: "font-medium sm:justify-self-end" }, je = /* @__PURE__ */ h({
  __name: "ErrorDetailsField",
  props: {
    label: {},
    value: {}
  },
  setup(e) {
    return (t, n) => (l(), v("div", qe, [
      b("div", ze, w(e.label) + ":", 1),
      b("div", null, w(e.value), 1)
    ]));
  }
}), Oe = {
  key: 0,
  class: "grid grid-cols-1 justify-start gap-3 p-2 sm:p-4 bg-surface-100 text-sm border-gray-300 text-gray-600 sm:grid-cols-[max-content_1fr] rounded-lg border"
}, He = /* @__PURE__ */ h({
  __name: "ErrorDetails",
  props: {
    error: {}
  },
  setup(e) {
    const { t } = Ke(), n = e, o = Me(), a = c(() => {
      const r = [];
      return n.error?.trackingId && r.push({
        label: t("errors.field.tracking_id.label"),
        value: n.error.trackingId
      }), o.value && n.error?.code && r.push({
        label: t("errors.field.code.label"),
        value: n.error.code
      }), o.value && n.error?.details && r.push({
        label: t("errors.field.details.label"),
        value: n.error.details
      }), r;
    });
    return (r, i) => a.value.length ? (l(), v("div", Oe, [
      (l(!0), v(P, null, A(a.value, (u, s) => (l(), f(je, {
        key: s,
        label: u.label,
        value: u.value
      }, null, 8, ["label", "value"]))), 128))
    ])) : k("", !0);
  }
});
function J(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "en",
    resource: {
      errors: {
        field: {
          code: {
            label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Error Code" } }
          },
          details: {
            label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Error Details" } }
          },
          tracking_id: {
            label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Tracking ID" } }
          }
        },
        general: {
          instructions: { t: 0, b: { t: 2, i: [{ t: 3, v: "Please contact your " }, { t: 4, k: "merchantName" }, { t: 3, v: " associate." }] } },
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "An unexpected error occurred." } }
        }
      }
    }
  });
}
typeof J == "function" && J(He);
const Lt = I(
  () => import("./ModalLauncherButton-BUbuxVfi.js")
), Rt = I(
  () => import("./ConfirmExitFlowButton-CrsxcGA2.js")
), We = { class: "text-center" }, ue = /* @__PURE__ */ h({
  __name: "PlanSummaryTab",
  props: {
    offer: {},
    vertical: {},
    active: { type: Boolean }
  },
  setup(e) {
    const t = e, n = c(() => ({
      id: `offer-tab-${t.offer.providerKey}`,
      class: [
        // Size
        "h-[75px]",
        "max-h-[75px]",
        "md:h-[68px]",
        "md:max-h-[68px]",
        "w-[132px]",
        "md:w-[320px]",
        "max-w-[320px]",
        // Padding
        "px-4",
        "py-2",
        // Makes the Tab and Tab-Body appear as a single item
        "-mb-[1px]",
        // Border
        "border",
        {
          "border-surface-300 border-b-surface-400": !t.active,
          "border-surface-400 border-b-transparent": t.active
        },
        "bg-surface-0",
        "rounded-t-2xl",
        "transition-all",
        // Layout
        "grid",
        "grid-cols-1",
        "grid-rows-[20px_1fr]",
        "md:grid-cols-2",
        "md:grid-rows-1",
        "gap-1",
        "justify-items-center"
      ]
    })), { te: o } = x(() => t.offer.providerKey), a = c(() => o(`approval-heading.${t.offer.productType}`) ? `approval-heading.${t.offer.productType}` : "approval-heading.credit"), r = we(), i = Ie(async () => {
      try {
        await r.publishPlansPresented([t.offer.providerKey]);
      } catch (u) {
        Ce(u);
      }
    }, 500);
    return $(
      () => t.active,
      (u) => {
        u && i();
      }
    ), $(
      () => t.offer,
      () => {
        t.active && i();
      }
    ), (u, s) => {
      const d = C("i18n-t");
      return l(), v("div", fe(ye(n.value)), [
        y(u.$slots, "logo", {}, () => [
          m(p(ne), {
            class: "logo h-max-[20px] md:h-max-[52px] h-full max-w-[112px] md:max-w-full",
            provider: e.offer.providerKey,
            vertical: e.vertical
          }, null, 8, ["provider", "vertical"])
        ], !0),
        b("div", We, [
          m(d, {
            keypath: a.value,
            tag: "p",
            class: "text-sm"
          }, null, 8, ["keypath"]),
          e.offer.response.approvedAmountCents ? (l(), f(p(M), {
            key: 0,
            value: e.offer.response.approvedAmountCents,
            class: "text-sm font-bold md:text-2xl",
            whole: ""
          }, null, 8, ["value"])) : k("", !0)
        ])
      ], 16);
    };
  }
});
function Q(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "en",
    resource: {
      "approval-heading": {
        credit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Credit Limit:
` } },
        lease: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Lease up to:
` } },
        loan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Loan up to:
` } }
      }
    }
  });
}
typeof Q == "function" && Q(ue);
const Ue = /* @__PURE__ */ le(ue, [["__scopeId", "data-v-2574094a"]]), Ge = { class: "flex flex-row gap-0.5" }, Et = /* @__PURE__ */ h({
  __name: "PlanSummaryTabs",
  props: /* @__PURE__ */ V({
    offers: {},
    vertical: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = T(e, "modelValue"), o = (a) => {
      n.value = a;
    };
    return be(() => {
      n.value == null && t.offers.length && (n.value = t.offers[0]);
    }), (a, r) => (l(), v("div", Ge, [
      (l(!0), v(P, null, A(e.offers, (i) => (l(), f(Ue, {
        key: `tab-${i.id}`,
        class: "cursor-pointer",
        offer: i,
        active: n.value?.id === i.id,
        vertical: e.vertical,
        onClick: (u) => o(i)
      }, {
        logo: _(() => [
          y(a.$slots, "logo", { offer: i })
        ]),
        _: 2
      }, 1032, ["offer", "active", "vertical", "onClick"]))), 128))
    ]));
  }
}), Je = {
  key: 0,
  class: "space-y-4 p-4"
}, Qe = { class: "flex flex-col gap-4" }, Ft = /* @__PURE__ */ h({
  __name: "PlanSummaryTabBody",
  props: /* @__PURE__ */ V({
    active: { type: Boolean },
    offer: {},
    selectable: { type: Boolean },
    purchaseAmount: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = T(e, "modelValue"), o = c({
      get() {
        return n?.value?.providerPlanCode;
      },
      set(a) {
        a == null ? n.value = void 0 : n.value = t.offer.plans.find(
          (r) => r.providerPlanCode === a
        );
      }
    });
    return Ae(
      {
        selectedPlanCode: o
      },
      {
        selectedPlanCode: {
          required: Te(() => t.selectable && t.active)
        }
      }
    ), (a, r) => e.active ? (l(), v("div", Je, [
      y(a.$slots, "header", { offer: e.offer }),
      b("div", Qe, [
        (l(!0), v(P, null, A(e.offer.plans, (i) => (l(), v("div", {
          key: i.providerPlanCode
        }, [
          y(a.$slots, "plan", {
            offer: e.offer,
            plan: i,
            selectable: !!e.selectable,
            selectedPlanCode: o.value,
            selectPlan: (u) => o.value = u
          })
        ]))), 128))
      ]),
      y(a.$slots, "footer", { offer: e.offer })
    ])) : k("", !0);
  }
}), Xe = ["id", "aria-selected", "aria-label"], Ze = ["for"], et = ["id", "name", "value", "aria-labelledby"], tt = { class: "flex grow flex-col items-center gap-4 bg-surface-0 p-4 md:flex-row" }, nt = { class: "logo h-auto w-35 min-w-35" }, ot = { class: "legal-font-size flex grow flex-col" }, at = { class: "mb-2 font-semibold text-primary-600" }, rt = /* @__PURE__ */ h({
  __name: "PlanCard",
  props: /* @__PURE__ */ V({
    plan: {},
    vertical: {},
    selectable: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = T(e, "modelValue"), n = e, o = c(
      () => `payment-plan-${n.plan.providerKey}-${n.plan.providerPlanCode}`
    ), a = c(
      () => `${n.plan.providerKey}-${n.plan.providerPlanCode}`
    ), r = c(
      () => `${a.value}-${n.plan.providerPlanCode}`
    ), i = c(() => t.value === n.plan.providerPlanCode), u = () => {
      n.selectable && (t.value = i.value ? void 0 : n.plan.providerPlanCode);
    };
    return (s, d) => (l(), v("div", {
      id: a.value,
      key: r.value,
      "aria-selected": i.value && e.selectable,
      "aria-label": e.plan.title,
      class: L([{
        "cursor-pointer grid-cols-[max-content_1fr]": e.selectable,
        "border-surface-600 bg-surface-0": !i.value || !e.selectable,
        "border-primary-600 bg-primary-600": i.value && e.selectable
      }, "plan-card-container grid overflow-hidden rounded-md border transition-colors"]),
      onClick: u
    }, [
      e.selectable ? (l(), v("div", {
        key: 0,
        class: L([{
          "border-r-surface-600": !i.value,
          "border-r-primary-600 bg-primary-600": i.value
        }, "grid h-full flex-col items-center border-r px-1 transition-colors"])
      }, [
        b("label", { for: o.value }, [
          i.value ? (l(), f(p(R), {
            key: 0,
            icon: p(Ve),
            class: "text-surface-0",
            size: "lg"
          }, null, 8, ["icon"])) : (l(), f(p(R), {
            key: 1,
            icon: p(Be),
            size: "lg"
          }, null, 8, ["icon"]))
        ], 8, Ze),
        _e(b("input", {
          id: o.value,
          "onUpdate:modelValue": d[0] || (d[0] = (D) => t.value = D),
          name: o.value,
          value: e.plan.providerPlanCode,
          "aria-labelledby": a.value,
          class: "hidden",
          type: "radio"
        }, null, 8, et), [
          [he, t.value]
        ])
      ], 2)) : k("", !0),
      b("div", tt, [
        b("div", nt, [
          y(s.$slots, "logo", { plan: e.plan }, () => [
            m(p(ne), {
              class: "logo h-max-[20px] md:h-max-[52px] h-full max-w-[112px] md:max-w-full",
              provider: e.plan.providerKey,
              vertical: e.vertical
            }, null, 8, ["provider", "vertical"])
          ], !0)
        ]),
        b("div", ot, [
          y(s.$slots, "title", { plan: e.plan }, () => [
            b("p", at, w(e.plan.title), 1)
          ], !0),
          y(s.$slots, "content", { plan: e.plan }, void 0, !0)
        ]),
        y(s.$slots, "payment", { plan: e.plan }, void 0, !0)
      ])
    ], 10, Xe));
  }
}), Nt = /* @__PURE__ */ le(rt, [["__scopeId", "data-v-7ebc334e"]]), it = { class: "grid min-h-20 min-w-44 grid-rows-[max-content] place-content-center gap-1 text-nowrap rounded-lg bg-surface-200 px-8 py-3 text-center text-base" }, lt = /* @__PURE__ */ h({
  __name: "PlanPayment",
  props: {
    plan: {}
  },
  setup(e) {
    const t = e;
    return x(() => t.plan.providerKey), (n, o) => {
      const a = C("i18n-t");
      return l(), v("div", it, [
        y(n.$slots, "payment", {}, () => [
          m(a, {
            keypath: "payment",
            tag: "p",
            "aria-labelledby": `${e.plan.providerPlanCode}-title ${e.plan.providerPlanCode}-paymentSuggestion`
          }, {
            value: _(() => [
              m(p(M), {
                value: e.plan.monthlyAmountCents ?? 0
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["aria-labelledby"])
        ]),
        y(n.$slots, "learnHowDrawer", { plan: e.plan })
      ]);
    };
  }
});
function X(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "en",
    resource: {
      payment: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `/mo
` }] } }
    }
  });
}
typeof X == "function" && X(lt);
const st = ["id"], ct = ["id"], ut = { key: 2 }, dt = /* @__PURE__ */ h({
  __name: "PlanCardAttribute",
  props: {
    attribute: {},
    plan: {}
  },
  setup(e) {
    const t = e, { t: n } = x(() => t.plan.providerKey), o = c(() => n(`attributes.${t.attribute}.label`)), a = c(
      () => t.plan[t.attribute] != null
    ), r = (s) => s === "firstPaymentDate" || s === "expireDateTime", i = (s, d, D) => n(
      `attributes.${s}.value`,
      {
        value: d
      },
      {
        plural: D
      }
    ), u = c(() => {
      const s = t.attribute, d = t.plan[s];
      return s === "apr" ? d : typeof d == "number" ? i(s, d, d) : typeof d == "string" && r(s) ? i(
        s,
        $e(d),
        Math.max(Pe(/* @__PURE__ */ new Date(), d), 0)
      ) : d;
    });
    return (s, d) => a.value ? (l(), v("div", {
      key: e.attribute,
      class: "grid grid-cols-[160px_minmax(0,1fr)] text-xs md:text-base"
    }, [
      b("p", {
        id: `${e.attribute}-label`,
        class: "font-medium"
      }, [
        y(s.$slots, "title", {}, () => [
          ke(w(o.value), 1)
        ])
      ], 8, st),
      b("p", {
        id: `${e.attribute}-value`,
        class: "place-self-start"
      }, [
        y(s.$slots, "value", {}, () => [
          e.attribute === "apr" ? (l(), f(p(pe), {
            key: 0,
            value: u.value
          }, null, 8, ["value"])) : e.attribute.includes("Cents") ? (l(), f(p(M), {
            key: 1,
            value: u.value,
            whole: !1
          }, null, 8, ["value"])) : (l(), v("span", ut, w(u.value), 1))
        ])
      ], 8, ct)
    ])) : k("", !0);
  }
});
function Z(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "en",
    resource: {
      attributes: {
        apr: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `APR:
` } },
          value: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `%
` }] } }
        },
        downPaymentCents: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Initial Payment:
` } },
          value: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `
` }] } }
        },
        durationMonths: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Term:
` } },
          value: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " Month" }] }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: ` Months
` }] }] } }
        },
        expireDateTime: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Approval Expires:
` } },
          value: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: " (" }, { t: 4, k: "count" }, { t: 3, v: " day)" }] }, { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: " (" }, { t: 4, k: "count" }, { t: 3, v: ` days)
` }] }] } }
        },
        financedAmountCents: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Amount Financed:
` } },
          value: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `
` }] } }
        },
        termMonths: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Term:
` } },
          value: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " Month" }] }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: ` Months
` }] }] } }
        },
        totalCostCents: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Total Amount:
` } },
          value: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `
` }] } }
        }
      }
    }
  });
}
typeof Z == "function" && Z(dt);
const pt = { key: 0 }, mt = /* @__PURE__ */ h({
  __name: "PlanDrawer",
  props: {
    plan: {}
  },
  setup(e) {
    const t = e, { t: n } = x(() => t.plan.providerKey), o = ae(!1);
    function a() {
      o.value = !0;
    }
    return (r, i) => {
      const u = Re, s = Le;
      return e.plan ? (l(), v("div", pt, [
        m(u, {
          visible: o.value,
          "onUpdate:visible": i[0] || (i[0] = (d) => o.value = d),
          position: "right",
          "block-scroll": "",
          class: "w-full max-w-[600px]"
        }, {
          header: _(() => [...i[1] || (i[1] = [
            b("p", { class: "w-full" }, null, -1)
          ])]),
          default: _(() => [
            y(r.$slots, "content", {
              plan: e.plan,
              isVisible: o.value
            })
          ]),
          _: 3
        }, 8, ["visible"]),
        m(s, {
          label: p(n)("open_label"),
          text: "",
          class: "text-nowrap !py-0",
          onClick: ge(a, ["stop"])
        }, null, 8, ["label"])
      ])) : k("", !0);
    };
  }
});
function ee(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "en",
    resource: {
      open_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Learn How" } }
    }
  });
}
typeof ee == "function" && ee(mt);
const te = {
  id: "default",
  steps: ["applicant", "terms", "decision"]
}, vt = {
  id: "review-and-accept-offer",
  steps: ["reviewOffer", "terms", "decision"]
}, ft = () => {
  const e = re(), t = Se(), n = ie();
  return c(() => {
    const o = n.currentProviderKey;
    return o && e.previousResponses.find(
      (r) => r.next?.provider?.providerKey === o
    )?.next?.applyMode === "prescreen" && t.fieldCount === 0 ? vt : te;
  });
};
function yt(e, t) {
  return typeof e == "object" && !!e[t];
}
const de = (e) => {
  const t = se(), n = re();
  return c(() => {
    const o = t.meta?.step;
    return o ? typeof o == "string" ? o : typeof o == "function" ? o(e.value.map((r) => r.id)) : n.applyMode && yt(o, n.applyMode) ? o[n.applyMode] : o["*"] : void 0;
  });
}, bt = (e) => {
  const { t } = e, n = ft(), o = (a) => ({
    id: a,
    label: (r) => t(`stepper.steps.${r}.label`)
  });
  return c(() => n.value.steps.map(o));
}, _t = (e) => {
  const t = ie(), n = ae(0), o = de(e);
  return $(o, (a, r) => {
    a && r && (n.value = e.value.findIndex(
      (i) => i.id === a
    ));
  }), $(
    () => t.currentProviderKey,
    () => {
      n.value = 0;
    }
  ), c(() => n.value);
}, ht = (e) => {
  const t = _t(e), n = de(e);
  return c(() => {
    const o = n.value;
    return o ? e.value.findIndex((a) => a.id === o) : t.value;
  });
}, Yt = (e) => {
  const t = bt(e), n = ht(t), o = se();
  return c(() => o.meta?.hideStepper ? [] : t.value.map((a, r) => n.value === r ? {
    ...a,
    status: "active"
  } : n.value > r ? {
    ...a,
    status: "complete"
  } : {
    ...a,
    status: "inactive"
  }));
};
export {
  nn as ApplicationFooter,
  jt as CheckDetails,
  Rt as ConfirmExitFlowButton,
  M as Currency,
  Ot as CurrencyHero,
  Ht as CurrencyPerPeriod,
  Bt as DisclosureDictionary,
  Wt as DownloadContentButton,
  ne as DynamicProviderLogo,
  He as ErrorDetails,
  Ut as IconHero,
  Gt as LenderAccountName,
  B as LenderBankName,
  K as LenderName,
  Lt as ModalLauncherButton,
  pe as Percent,
  Nt as PlanCard,
  dt as PlanCardAttribute,
  mt as PlanDrawer,
  lt as PlanPayment,
  Ft as PlanSummaryTabBody,
  Et as PlanSummaryTabs,
  on as ProviderApplicationDocuments,
  Jt as ProviderDecisionDataTable,
  Qt as RequiredNote,
  Xt as TermsModal,
  sn as TermsModalLink,
  an as TermsViewer,
  rn as VersatilePrivacyPolicyLink,
  Zt as ViewTitle,
  en as defineProviderDecisionTable,
  Fe as useLocalizedComponents,
  Yt as useStepperSteps
};
//# sourceMappingURL=index.es.js.map
